import LayoutPublic from '../component/web/layout/layoutPublic'
import FormComponent from '../component/um/forgot-password/Form'
import Container from '@material-ui/core/Container'
import { Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import useTranslate from '../i18n/useTranslate'

const ForgotPassword = () => {
    const classes = useStyles()
    const translate = useTranslate()

    return (
        <>
            <LayoutPublic>
                <Container maxWidth="md" className={classes.rootContainer}>
                    <div style={{ display: 'grid', justifyContent: 'center', alignContent: 'center' }}>
                        <Grid container justify="center" alignContent="center" className={classes.root}>
                            <Grid item xs={12} md={10} lg={8} className={classes.item}>
                                <Paper className={classes.paper}>
                                    <Grid container className={classes.container}>
                                        <Grid item xs={12}>
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/img/Chulalongkorn_University_Alt_Logo.svg.png'
                                                }
                                                width={'auto'}
                                                height="60px"
                                                alt="chula"
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography className={classes.typo}>
                                                {translate.get('UM.FORGOTPASSWORD.HEADER')}
                                            </Typography>
                                        </Grid>

                                        <FormComponent />
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </LayoutPublic>
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    rootContainer: {
        minHeight: 'calc(100vh - 96px)',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            padding: '0px',
        },
    },
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    item: {
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    paper: {
        width: '100%',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
    },
    container: {
        padding: '1.5rem',
    },
    typo: {
        fontWeight: 'bold',
    },
}))

export default ForgotPassword
